import gql from 'graphql-tag';

export const LivePageContentQuery = gql`
	query LivePageContentQuery($contentId: ID) {
		singleContent(id: $contentId) {
			id
			space {
				id
			}
			history {
				createdDate
			}
		}
	}
`;
